export const LandingCodes = {
  AADVANTAGE: 'aadvantage'
};
